export const VoiceCallRequestType = Object.freeze({
    startVoiceCall: "StartVoiceCall",
    endVoiceCall: "EndVoiceCall",
});
